import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {dismissAlert} from '/redux/action/client.action';
import {
  activatedOnById,
  allAlertsById,
  allAlertsState,
  hasAllAlertsById,
  ordersById,
} from '/redux/selector/client.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {allReportData} from '/redux/selector/report.selector';

import {Alerts} from './Alerts';

export default connect(
  createStructuredSelector({
    alerts: allAlertsById,
    alertsState: allAlertsState,
    hasAlerts: hasAllAlertsById,
    orders: ordersById,
    activatedOn: activatedOnById,
    allReportData,
    featureFlag: variablesFeatureFlag,
  }),
  dispatch => ({
    dismissAlert: ({
      clientId,
      type,
      dismissStatus,
      allReportData,
      lastOrderedOn,
      orderId,
      premierOrderId,
      rewardId,
      latestExpiryDate,
    }: any) =>
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        dismissAlert({
          clientId,
          type,
          dismissStatus,
          allReportData,
          lastOrderedOn,
          orderId,
          premierOrderId,
          rewardId,
          latestExpiryDate,
        }),
      ),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    dismissAlert: ({
      type,
      dismissStatus,
      lastOrderedOn,
      orderId,
      premierOrderId,
      rewardId,
      latestExpiryDate,
    }: any) => {
      const {clientId} = ownProps;
      const {allReportData} = stateProps;
      return dispatchProps.dismissAlert({
        clientId,
        type,
        dismissStatus,
        allReportData,
        lastOrderedOn,
        orderId,
        premierOrderId,
        rewardId,
        latestExpiryDate,
      });
    },
  }),
)(Alerts);
